module.exports = __webpack_public_path__ + "img/instagram.7a4aebc6.svg";